import React, { useState } from 'react'
import { Breadcrumb, Card, Col, Row, Form, Button } from 'react-bootstrap'
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import Layout from '../../layout/Layout'
import {toast} from 'react-toastify'
import { Link, useNavigate } from 'react-router-dom'
import { API } from '../../App'
import { useEffect } from 'react'
import Cookies from 'js-cookie'
const LoanDetailAdd = () => {
  const tokenAuth = async () => {
    const token = Cookies.get('jwt')
    const response = await API.post("/home", {}, { headers: { "Authorization": `Bearer ${token}` } })
    if (response.data.status === false) {
      navigate("/")
    }
  }
  const [validate,setValidate] = useState(false)
  const navigate = useNavigate()
  const [loan, setLoan] = useState([])
  const [bank, setBank] = useState([])
  const getData = async () => {
    const token = Cookies.get('jwt')
    const loanRes = await API.post("/getLoan", {}, { headers: { "Authorization": `Bearer ${token}` } })
    if (loanRes.data.status === false) {
      if (loanRes.data.response_code === 429) {
        navigate("/")
      } else {
        toast.error('Something went wrong in Loan List')
      }
    } else {
      setLoan(loanRes.data.data.data)
    }
    const bankRes = await API.post("/getLoanBank", {}, { headers: { "Authorization": `Bearer ${token}` } })
    if (loanRes.data.status === false) {
      if (loanRes.data.response_code === 429) {
        navigate("/")
      } else {
        toast.error('Something went wrong in Bank List')
      }
    } else {
      setBank(bankRes.data.data)
    }

    // console.log(data);
  }

  const [status, setStatus] = useState(1)
  const [inpData, setInpData] = useState({
    Loan: "",
    Bank: "",
    Interest: "",
    Process: "",
    Amount: "",
    Tenure: "",
  })
  const getValue = (e) => {
    setInpData({ ...inpData, [e.target.name]: e.target.value })
  }

  const saveData = async () => {
    if (inpData.Loan === "" || inpData.Bank === "" || inpData.Interest === "" || inpData.Process === "" || inpData.Amount === "" ||
      inpData.Tenure === "") {
        setValidate(true)
    } else {
      const Form = new FormData()
      Form.append('loan', inpData.Loan)
      Form.append('bank', inpData.Bank)
      Form.append('interest', inpData.Interest)
      Form.append('process', inpData.Process)
      Form.append('amount', inpData.Amount)
      Form.append('tenure', inpData.Tenure)
      Form.append('status', status)
      const token = Cookies.get('jwt')
      const response = await API.post("/addLoanDetail", Form, { headers: { "Authorization": `Bearer ${token}` } })
      if (response.data.status === true) {
        toast.success('Loan Detail Added Succesfully')
        navigate("/loandetail")
      } else {
        if (response.data.response_code === 429) {
          navigate("/")
        } else {
          toast.error('Something went wrong')
        }
      }
    }
  }

  useEffect(() => {
    tokenAuth()
    getData()
  }, [])
  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3>Add Loan Detail</h3>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/"><i className='bx bx-home-alt me-2 fs-5' ></i> Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/loandetail">Loan Detail List</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Add New Loan Detail</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="page-content">
      <Form noValidate validated={validate}>
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Body>
                <Row className='align-items-center'>
                  <Col lg={3} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='loan-name'>Loan Name</Form.Label>
                      <Form.Select id="loan-name" className="my-2" name='Loan' onChange={(e) => { getValue(e) }} required>
                        <option value="">Select Loan Name</option>
                        {
                          loan.map((dataVal, ind) => {
                            return (
                              <option value={dataVal._id} key={ind}>{dataVal.name}</option>
                            )
                          })
                        }
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='bank-name'>Bank Name</Form.Label>
                      <Form.Select id="bank-name" className="my-2" name='Bank' onChange={(e) => { getValue(e) }} required>
                        <option value="">Select Bank Name</option>
                        {
                          bank.map((dataVal, ind) => {
                            return (
                              <option value={dataVal._id} key={ind}>{dataVal.name}</option>
                            )
                          })
                        }
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='loan-desc'>Intrest Rate</Form.Label>
                      <Form.Control type="text" className="my-2" id='loan-desc' value={inpData.Interest} name='Interest' onChange={(e) => { getValue(e) }} placeholder="Enter Your Intrest Rate" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='loan-pfee'>Process Fee</Form.Label>
                      <Form.Control type='text' className="my-2" id='loan-pfee' value={inpData.Process} name='Process' onChange={(e) => { getValue(e) }} placeholder="Enter Your Process Fee" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='loan-amt'>Loan Amount</Form.Label>
                      <Form.Control type='text' className="my-2" id='loan-amt' value={inpData.Amount} name='Amount' onChange={(e) => { getValue(e) }} placeholder="Enter Your Loan Amount" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='loan-tenure'>Tenure</Form.Label>
                      <Form.Control type='text' className="my-2" id='loan-tenure' value={inpData.Tenure} name='Tenure' onChange={(e) => { getValue(e) }} placeholder="Enter Your Tenure" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={3} >
                    <Form.Group>
                      <Form.Label className="d-block mb-2" htmlFor='loan-status'>Status </Form.Label>
                      <BootstrapSwitchButton id="loan-status" checked={true} onlabel='Enable' onChange={(checked) => { if (checked === true) { setStatus(1) } else { setStatus(0) } }} offlabel='Disable' width={125} />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer className="text-end">
                <Button variant="primary" className="me-3" onClick={saveData}>Save</Button>
                <Link to="/loandetail">
                  <Button variant="secondary">Cancle</Button>
                </Link>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Form>
      </div>
    </Layout>
  )
}

export default LoanDetailAdd